import Head from 'next/head';

const SEO = ({
  title = "Serving God's Children – Empowering Communities in Guatemala",
  description = "Serving God's Children empowers underprivileged children, adults, and communities in Guatemala through education, nutrition, and love.",
  url = "https://servinggodschildren.com/",
  image = "https://prod.servinggodschildren.com/logo.png",
  canonical = "https://servinggodschildren.com/"
}) => {
  return (
    <Head>
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="robots" content="index, follow" />
      <meta name="language" content="English" />

      {/* Open Graph */}
      <meta property="og:url" content={url} />
      <meta property="og:type" content="website" />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta property="twitter:url" content={url} />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />

      <link rel="canonical" href={canonical} />
    </Head>
  );
};

export default SEO;
